import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import ChevronLeftIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(theme => ({
  button: {
    background: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    position: 'relative',
    width: 36,
    zIndex: 2,

    [theme.breakpoints.up('sm')]: {
      background: 'white',
      border: `2px solid ${theme.palette.secondary.main}`,
      borderRadius: 36,
      boxShadow: '4px 2px 6px #b3b3b3',
      height: 36,
      position: 'absolute',
      top: 100
    },
    transform: 'translate3d(0,0,0)'
  },
  buttonOpen: {
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    [theme.breakpoints.up('sm')]: {
      left: 253
    }
  },
  buttonClosed: {
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up('sm')]: {
      left: 40
    }
  },
  icon: {
    color: theme.palette.secondary.main
  },
  desktopButtonOpen: {
    transform: 'rotate(180deg)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  },
  desktopButtonClosed: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short
    })
  }
}));

interface ToggleButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isDesktop?: boolean;
  open?: boolean;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ isDesktop, onClick, open }) => {
  const classes = useStyles();
  const { t } = useTranslation('ToggleButton');

  return (
    <Fab
      aria-label={t('Toggle Navigation Drawer')}
      className={clsx(classes.button, {
        [classes.buttonOpen]: open,
        [classes.buttonClosed]: !open
      })}
      onClick={onClick}
    >
      {isDesktop ? (
        <ChevronLeftIcon
          className={clsx(classes.icon, {
            [classes.desktopButtonOpen]: open,
            [classes.desktopButtonClosed]: !open
          })}
        />
      ) : (
        <CloseIcon className={classes.icon} />
      )}
    </Fab>
  );
};

export default ToggleButton;
